export default {"src":"/_next/static/media/snapchat.cb6aeaa8.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};